import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-e-filling-guidance',
    templateUrl: './e-filling-guidance.component.html',
    styleUrls: ['./e-filling-guidance.component.css'],
    standalone: false
})
export class EfillingGuidanceComponent implements OnInit {

  constructor () { }

  ngOnInit () {
  }

}
